import React from "react";
import { Switch, FormControlLabel, Box, Typography } from "@mui/material";
import { useDarkmode } from "../../hooks/useDarkmode";
import { T } from "../../components/T";

const DarkmodeToggle = () => {
  const { isDarkmode, toggleDarkmode } = useDarkmode();

  const handleToggle = () => {
    toggleDarkmode();
  };

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <FormControlLabel
          control={
            <Switch
              checked={isDarkmode}
              onChange={handleToggle}
              color="secondary"
            />
          }
          label={
            <Typography sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <T str="Dark mode" />
            </Typography>
          }
        />
      </Box>
    </>
  );
};

export default DarkmodeToggle;
